import React from "react";
import { useSelector, useDispatch } from "react-redux";
import useKeypress from "react-use-keypress";

import Skeleton from "@material-ui/lab/Skeleton";
import { Box } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

import { Tab, Tabs, Beta } from "../../Theme";
import Loading from "../../Components/Loading";
import { setProductDialogState } from "../../Store/Modules/Dialogs/Actions";
import { api } from "../../Services/Api";
import TabPanel from "./TabPanel";
import ProducInfo from "./ProductInfo";
import AnswersTab from "./AnswersTab";
import { Container } from "./style";
import { ProductContext } from "./ProductContext";

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
  };
}

export default function ProductEdit({ id }) {
  const dispatch = useDispatch();
  const [product, setProduct] = React.useState(null);
  const [loading, setLoading] = React.useState(false);

  const activeTab = useSelector(
    (state) => state.dialogs.editProductDialog.activeTab
  );

  const menu = useSelector((state) => state.menu);

  const productList = menu.menu.flatMap((categoria) => categoria.itens);

  const indexCurrent = productList.findIndex((item) => item._id === id);

  const INDEX_FIRST_ITEM = 0;
  const INDEX_LAST_ITEM = productList.length - 1;

  const nextItem =
    productList[
      indexCurrent === INDEX_LAST_ITEM ? INDEX_LAST_ITEM : indexCurrent + 1
    ];

  const previousItem =
    productList[
      indexCurrent === INDEX_FIRST_ITEM ? INDEX_FIRST_ITEM : indexCurrent - 1
    ];

  const handleChange = (event, newValue) => {
    dispatch(setProductDialogState("activeTab", newValue));
  };

  function getProduct(idProduct) {
    setLoading(true);
    api
      .get(`/menu/products/${idProduct}/info`)
      .then(({ data }) => setProduct(data))
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  }

  function goPrevious() {
    dispatch(
      setProductDialogState("data", {
        productId: previousItem._id,
        printDescription: previousItem.printDescription,
      })
    );
  }

  function goNext() {
    dispatch(
      setProductDialogState("data", {
        productId: nextItem._id,
        printDescription: nextItem.printDescription,
      })
    );
  }

  useKeypress(["ArrowLeft", "ArrowRight"], (event) => {
    if (!event.ctrlKey) return;
    
    if (event.key === "ArrowLeft") {
      goPrevious();
    }
    if (event.key === "ArrowRight") {
      goNext();
    }
  });

  React.useEffect(() => {
    if (id) {
      setTimeout(() => {
        getProduct(id);
      }, 1000);
    }
  }, [id]);

  if (!product || loading)
    return (
      <Container>
        <Box display="flex" gridGap={"20px"}>
          <Skeleton variant="text" width="100px" />{" "}
          <Skeleton width="100px" variant="text" />
        </Box>
        <Box display="flex" gridGap={"20px"}>
          <Box>
            <Skeleton variant="rect" width={230} height={180} />
          </Box>
          <Box
            width="100%"
            display="flex"
            gridGap={"20px"}
            flexDirection="column"
          >
            <Skeleton variant="rect" width={"100%"} height={50} />
            <Skeleton variant="rect" width={"100%"} height={100} />
            <Skeleton variant="rect" width={100} height={50} />
          </Box>
        </Box>
      </Container>
    );

  return (
    <ProductContext initialState={product}>
      <Container>
        <Tabs value={activeTab} onChange={handleChange}>
          <Tab label="Informações" {...a11yProps(0)} />
          <Tab label={`Perguntas ou adicionais`} {...a11yProps(1)} />
        </Tabs>
        <TabPanel value={activeTab} index={0}>
          <ProducInfo />
        </TabPanel>
        <TabPanel value={activeTab} index={1}>
          <AnswersTab />
        </TabPanel>
        <Box position="absolute" bottom="0" left="0">
          <Button
            disabled={indexCurrent === INDEX_FIRST_ITEM}
            onClick={goPrevious}
            color="primary"
          >
            <FiChevronLeft style={{ fontSize: "40px" }} />
          </Button>
        </Box>
        <Box position="absolute" bottom="0" right="0">
          <Button
            disabled={indexCurrent === INDEX_LAST_ITEM}
            onClick={goNext}
            size="small"
            color="primary"
          >
            <FiChevronRight style={{ fontSize: "40px" }} />
          </Button>
        </Box>
      </Container>
    </ProductContext>
  );
}
